<div class="loan-purpose-selection-component">
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Loan purpose</mat-label>
          <mat-select [formControl]="formControl" [disabled]="isDropdownDisabled()">
            @if (!isDropdownDisabled()) {
              @for (option of filteredOptions; track option) {
                <mat-option [value]="option" [disabled]="isOptionDisabled(option)">{{option.name}}</mat-option>
              }
            }
          </mat-select>
          @for (errorKey of errorKeys(formControl); track errorKey) {
            <mat-error>
              @if (formControl.touched && formControl.hasError(errorKey)) {
                {{errorMessage(formControl, errorKey)}}
              }
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    @if (showIncomeGeneratingAsset) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="form-field">
            <div class="switch-container">
              <span class="switch-label">Is this an income generating asset?</span>
              <mat-slide-toggle formControlName="isIncomeGeneratingAsset"></mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>
    }

    @if (showExpectedMonthlyIncome) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Expected Additional Monthly Income</mat-label>
            <input matInput type="number" formControlName="expectedMonthlyIncome" placeholder="Enter amount">
            @for (errorKey of errorKeys(formGroup.get('expectedMonthlyIncome')!); track errorKey) {
              <mat-error>
                @if (formGroup.get('expectedMonthlyIncome')?.touched && formGroup.get('expectedMonthlyIncome')?.hasError(errorKey)) {
                  {{errorMessage(formGroup.get('expectedMonthlyIncome')!, errorKey)}}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    @if (showExistingFinanceCommitments) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="form-field">
            <div class="switch-container">
              <span class="switch-label">Does this asset have any existing finance commitments?</span>
              <mat-slide-toggle formControlName="hasExistingFinanceCommitments"></mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>
    }

    @if (showLender) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Lender</mat-label>
            <input matInput formControlName="lender" placeholder="Enter lender name">
            @for (errorKey of errorKeys(formGroup.get('lender')!); track errorKey) {
              <mat-error>
                @if (formGroup.get('lender')?.touched && formGroup.get('lender')?.hasError(errorKey)) {
                  {{errorMessage(formGroup.get('lender')!, errorKey)}}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    @if (showLoanValue) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Loan Value</mat-label>
            <input matInput type="number" formControlName="loanValue" placeholder="Enter loan value">
            @for (errorKey of errorKeys(formGroup.get('loanValue')!); track errorKey) {
              <mat-error>
                @if (formGroup.get('loanValue')?.touched && formGroup.get('loanValue')?.hasError(errorKey)) {
                  {{errorMessage(formGroup.get('loanValue')!, errorKey)}}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    @if (showTaxBalance) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Tax Balance</mat-label>
            <input matInput type="number" formControlName="taxBalance" placeholder="Enter tax balance">
            @for (errorKey of errorKeys(formGroup.get('taxBalance')!); track errorKey) {
              <mat-error>
                @if (formGroup.get('taxBalance')?.touched && formGroup.get('taxBalance')?.hasError(errorKey)) {
                  {{errorMessage(formGroup.get('taxBalance')!, errorKey)}}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    @if (showPurchasePrice) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Purchase Price</mat-label>
            <input matInput type="number" formControlName="purchasePrice" placeholder="Enter purchase price">
            @for (errorKey of errorKeys(formGroup.get('purchasePrice')!); track errorKey) {
              <mat-error>
                @if (formGroup.get('purchasePrice')?.touched && formGroup.get('purchasePrice')?.hasError(errorKey)) {
                  {{errorMessage(formGroup.get('purchasePrice')!, errorKey)}}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    @if (showPurposeDescription) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Purpose Description - {{furtherDescriptionLabel}}</mat-label>
            <textarea matInput formControlName="purposeDescription" placeholder="Enter purpose description" rows="3"></textarea>
            @for (errorKey of errorKeys(formGroup.get('purposeDescription')!); track errorKey) {
              <mat-error>
                @if (formGroup.get('purposeDescription')?.touched && formGroup.get('purposeDescription')?.hasError(errorKey)) {
                  {{errorMessage(formGroup.get('purposeDescription')!, errorKey)}}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }
  </form>
</div>
